import type { IGetCustomerOrderDetailsQuery } from "../../../types";
import { ICountryCodeEnum, ICurrencyEnum } from "../../../types";

export const getCustomerOrderDetailsMock: IGetCustomerOrderDetailsQuery = {
  customer: {
    orders: {
      items: [
        {
          id: "NTE4Njc=",
          order_date: "2024-09-23 15:22:25",
          website_code: "base",
          has_withdrawal: false,
          withdrawal_id: "",
          status: "Canceled",
          status_reason: {
            reason_code: "",
            reason_message: "",
          },
          items: [
            {
              id: "NzY5NDQ=",
              product: {
                __typename: "BundleProduct",
                color_label: "",
                enable_order_quantity_limit: 0,
                order_quantity_limit: 1,
                hidden_sku: false,
                subscription: 0,
                is_discontinued: false,
                categories: [
                  {
                    name: "Products",
                    uid: "NDQ=",
                  },
                ],
                image: {
                  url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_2_1.jpg",
                },
              },
              product_type: "bundle",
              product_name: "Camel Gold - carton - subscription",
              selected_options: [],
              quantity_ordered: 1,
              quantity_refunded: 0,
              quantity_canceled: 0,
              row_total: {
                currency: ICurrencyEnum.Eur,
                value: 222.22,
              },
              row_total_incl_tax: {
                currency: ICurrencyEnum.Eur,
                value: 222.22,
              },
              product_sale_price: {
                value: 222.22,
                currency: ICurrencyEnum.Eur,
              },
              product_sale_price_incl_tax: {
                currency: ICurrencyEnum.Eur,
                value: 222.22,
              },
              product_sku: "sticks-carton-gold-subscription",
              gift_data: {
                is_gift: false,
                parent_gift_sku: "",
                parent_gift_id: "",
              },
              bundle_options: [
                {
                  id: "NDY1Mg==",
                  label: "packs",
                  values: [
                    {
                      uid: "YnVuZGxlLzQ2NTIvNDczNy8x",
                      id: "NzY5NDU=",
                      product_name: "Camel Gold - pack",
                      quantity: 10,
                      presentation_info: {
                        initial_price: 22.22,
                        presentation_price: 0,
                        product: {
                          uid: "MTM2MDA=",
                          id: 13600,
                          tooltip_info: "",
                          is_discontinued: false,
                          small_image: {
                            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/2/_/2_1.jpg",
                          },
                        },
                      },
                    },
                  ],
                },
                {
                  id: "NDY1Mw==",
                  label: "packs",
                  values: [
                    {
                      uid: "YnVuZGxlLzQ2NTMvNDczOC8z",
                      id: "NzQ0MDQ=",
                      product_name: "Camel Bronze - pack",
                      quantity: 10,
                      presentation_info: {
                        initial_price: 11.11,
                        presentation_price: 0,
                        product: {
                          uid: "MTM1OTg=",
                          id: 13598,
                          tooltip_info: "",
                          is_discontinued: false,
                          small_image: {
                            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/r/bronze.jpg",
                          },
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: "NDQ1OTk=",
              product: {
                __typename: "SimpleProduct",
                color_label: "Dark Blue Classic",
                enable_order_quantity_limit: 1,
                order_quantity_limit: 2,
                hidden_sku: false,
                subscription: 0,
                is_discontinued: false,
                categories: [
                  {
                    name: "Acquista",
                    uid: "NDI=",
                  },
                  {
                    name: "Device",
                    uid: "NDM=",
                  },
                ],
                image: {
                  url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/n/e/neutral_matte_black_ro_6tbu5.png",
                },
              },
              product_type: "simple",
              product_name: "Ploom Mat",
              selected_options: [],
              quantity_ordered: 1,
              quantity_refunded: 0,
              quantity_canceled: 0,
              row_total: {
                currency: ICurrencyEnum.Eur,
                value: 75000.98,
              },
              row_total_incl_tax: {
                currency: ICurrencyEnum.Eur,
                value: 75000.98,
              },
              product_sale_price: {
                value: 75000.98,
                currency: ICurrencyEnum.Eur,
              },
              product_sale_price_incl_tax: {
                currency: ICurrencyEnum.Eur,
                value: 75000.98,
              },
              product_sku: "20BD272250",
              gift_data: {
                is_gift: false,
                parent_gift_sku: "",
                parent_gift_id: "",
              },
            },
            {
              id: "NzczMjI=",
              product: {
                __typename: "BundleProduct",
                color_label: " ",
                enable_order_quantity_limit: 0,
                order_quantity_limit: 1,
                hidden_sku: false,
                subscription: 1,
                is_discontinued: false,
                categories: [
                  {
                    name: "Products",
                    uid: "NDQ=",
                  },
                ],
                image: {
                  url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/r/bronze_1.jpg",
                },
              },
              product_type: "bundle",
              product_name: "Camel Bronze - carton",
              selected_options: [],
              quantity_ordered: 1,
              quantity_refunded: 0,
              quantity_canceled: 1,
              row_total: {
                currency: ICurrencyEnum.Eur,
                value: 55.56,
              },
              row_total_incl_tax: {
                currency: ICurrencyEnum.Eur,
                value: 55.56,
              },
              product_sale_price: {
                value: 55.56,
                currency: ICurrencyEnum.Eur,
              },
              product_sale_price_incl_tax: {
                currency: ICurrencyEnum.Eur,
                value: 55.56,
              },
              product_sku: "sticks-carton-bronze",
              gift_data: {
                is_gift: false,
                parent_gift_sku: "",
                parent_gift_id: "",
              },
              bundle_options: [
                {
                  id: "NDcxMg==",
                  label: "packs",
                  values: [
                    {
                      uid: "YnVuZGxlLzQ3MTIvNDg0Ny8x",
                      id: "NzczMjM=",
                      product_name: "Camel Bronze - pack",
                      quantity: 10,
                      presentation_info: {
                        initial_price: 11.11,
                        presentation_price: 11.11,
                        product: {
                          uid: "MTM1OTg=",
                          id: 13598,
                          tooltip_info: "",
                          is_discontinued: false,
                          small_image: {
                            url: "https://m24-fe1.dev-jtides.com/media/catalog/product/cache/8bfcefb3f907ea84b6e8d07d75ca72eb/b/r/bronze.jpg",
                          },
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          additional_attributes: [
            {
              attribute_code: "heureka_consent",
              value: "0",
            },
            {
              attribute_code: "test_attribute_textfield",
              value: "",
            },
            {
              attribute_code: "test_attribute_radiobuttons",
              value: "",
            },
            {
              attribute_code: "vat_number",
              value: "",
            },
            {
              attribute_code: "company_number_field",
              value: "",
            },
            {
              attribute_code: "numer_nip",
              value: "",
            },
            {
              attribute_code: "address",
              value: "",
            },
            {
              attribute_code: "zip_code",
              value: "",
            },
            {
              attribute_code: "town",
              value: "",
            },
            {
              attribute_code: "something_else",
              value: "0",
            },
            {
              attribute_code: "vat_id",
              value: "",
            },
          ],
          shipping_address: {
            firstname: "Oksana",
            lastname: "Kohutych",
            street: ["Salezianov", "6"],
            city: "Michalovce",
            country_code: ICountryCodeEnum.De,
            postcode: "071 01",
            telephone: "+493454353453",
            pickup_information: "",
            administrative_area_level_2: "",
            sublocality_level_2: "",
            premise: "premise_Test",
            neighborhood: "neighborhood_Test",
            landmark: "landmark_Test",
            building_number: "buildingNumber_Test",
            district: "district_Test",
            region: "",
            region_code: "",
            region_id: "0",
          },
          billing_address: {
            firstname: "Oksana",
            lastname: "Kohutych",
            street: ["Salezianov", "6"],
            city: "Michalovce",
            postcode: "071 01",
            country_code: ICountryCodeEnum.De,
            administrative_area_level_2: "",
            sublocality_level_2: "",
            premise: "premise_Test",
            neighborhood: "neighborhood_Test",
            landmark: "landmark_Test",
            building_number: "buildingNumber_Test",
            district: "district_Test",
            region: "",
            region_code: "",
            region_id: "0",
          },
          shipping_method: "Free Shipping - Free",
          loyalty_info: {
            loyalty_discount_amount: 0,
            loyalty_discount_points: 0,
            loyalty_discount_uuid: "",
          },
          shipments: [],
          payment_methods: [
            {
              type: "jtipayment",
              name: "JTI_Payment",
              method_code: "",
              additional_data: [],
            },
          ],
          total: {
            subtotal: {
              currency: ICurrencyEnum.Eur,
              value: 67.56,
            },
            subtotal_incl_tax: {
              currency: ICurrencyEnum.Eur,
              value: 67.56,
            },
            taxes: [],
            discounts: [],
            total_shipping: {
              currency: ICurrencyEnum.Eur,
              value: 0,
            },
            total_refunded: {
              currency: ICurrencyEnum.Eur,
              value: 0,
            },
            grand_total: {
              value: 67.56,
              currency: ICurrencyEnum.Eur,
            },
            total_after_refund: {
              value: 67.56,
              currency: ICurrencyEnum.Eur,
            },
          },
          total_after_trial: {
            total: {
              value: 0,
              currency: ICurrencyEnum.Eur,
            },
            total_incl_tax: {
              value: 0,
              currency: ICurrencyEnum.Eur,
            },
            tax: {
              value: 0,
              currency: ICurrencyEnum.Eur,
            },
          },
          invoices: [],
        },
      ],
    },
  },
} as const;
